<template>
  <div class="form-group">
    <validation-provider name="date" rules="required|date_format:DD MM YYYY|min_age:18|max_age:100"
                         v-slot="{ errors }" mode="eager">
      <label for="date"></label>
      <input
        type="text"
        id="date"
        class="input-code input-code--font-small"
        :value="value"
        @input="$emit('input', $event.target.value)"
        v-input-mask
        data-inputmask-mask="99 99 9999"
        data-inputmask-placeholder="DD MM YYYY"
        data-inputmask-clearMaskOnLostFocus="false"
      >
      <div class="text-danger login-card--small-line-height">{{ errors[0] }}</div>
    </validation-provider>
  </div>
</template>
<script>
import { extend } from 'vee-validate';
import moment from 'moment';

extend('date_format', {
  validate(value, { format }) {
    return moment(value, 'DD MM YYYY').format(format) === value;
  },
  params: ['format'],
});

extend('min_age', {
  validate(value, { min }) {
    const birthDate = moment(value, 'DD MM YYYY', true);
    const today = moment();
    const minAgeDate = today.subtract(min, 'years');

    return birthDate.isSameOrBefore(minAgeDate, 'day');
  },
  params: ['min'],
});

extend('max_age', {
  validate(value, { max }) {
    const birthDate = moment(value, 'DD MM YYYY', true);
    const today = moment();
    const maxAgeDate = today.subtract(max, 'years');

    return birthDate.isSameOrAfter(maxAgeDate, 'day');
  },
  params: ['max'],
});

export default {
  props: ['value'],
};
</script>
<style scoped>
</style>
